<template>
  <CMachinesList
    :vending-machines="machinesWithAddress"
    :is-loading="!isLoaded"
    title="Наши автоматы:"
    :is-location-loading="isLocationLoading"
    :is-filtering-by-location-available="!!userLocation"
    :is-filtering-by-location-enabled="filterByLocationCheckbox"
    :is-filtering-by-location-loading="isFilteringByLocationLoading"
    :vending-machines-for-user-location-error="vendingMachinesForUserLocationError"
    @update:filter-by-location-checkbox="filterByLocationCheckbox = $event"
  >
    <template #link>Показать товары</template>
  </CMachinesList>
</template>

<script setup lang="ts">
  import { computed, onMounted } from 'vue';

  import { useVendingMachinesList } from '@/composables/useVendingMachinesList';

  import CMachinesList from '../MachinesList/CMachinesList.vue';

  const {
    createSortMachinesComputed,
    userLocation,
    isFilteringByLocationLoading,
    isLoaded,
    isLocationLoading,
    filterByLocationCheckbox,
    vendingMachinesForUserLocationError
  } = useVendingMachinesList();

  const { sortedMachines, initUserLocation } = createSortMachinesComputed();

  const machinesWithAddress = computed(
    () => sortedMachines.value?.filter(machine => machine.attributes.address) ?? []
  );

  onMounted(async () => {
    await initUserLocation();
  });
</script>
